package com.klantenstop.web.data.models.dto.requests.reviews

import kotlinx.serialization.Serializable

@Serializable
data class UpdateReview(
    val text: String? = null,
    val rating: Int? = null,
)
